var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('fieldset',{attrs:{"id":"map-bottom-point-cloud"}},[_c('legend',{staticClass:"info-header font-h2"},[_vm._v(_vm._s(_vm.iframeTitle))]),_c('div',{staticClass:"flex-justify"},[_c('iframe',{staticClass:"cloud",attrs:{"src":_vm.pointUrl}})])])}
var staticRenderFns = []

export { render, staticRenderFns }